













import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class ActionMenu extends Vue {
  @Prop()
  canShow: boolean;

  toggle () {
    this.$emit("onToggle");
  }
}
